import _classCallCheck from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
/*
 * EV User Search API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.33
 *
 * Do not edit the class manually.
 *
 */
import { ApiClient } from "../ApiClient";

/**
 * EvRepository service.
 * @module api/EvRepositoryApi
 * @version 1.0
 */
export var EvRepositoryApi = /*#__PURE__*/function () {
  /**
    * Constructs a new EvRepositoryApi. 
    * @alias module:api/EvRepositoryApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
  function EvRepositoryApi(apiClient) {
    _classCallCheck(this, EvRepositoryApi);
    this.apiClient = apiClient || ApiClient.instance;
  }

  /**
   * Delete bentity item from the database
   * @param {module:model/String} table
   * @param {String} deleteid
   * @param {Object} opts Optional parameters
   * @param {module:model/String} opts.xHTTPMethodOverride  (default to <.>)
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
   */
  _createClass(EvRepositoryApi, [{
    key: "deleteItemResourceWithHttpInfo",
    value: function deleteItemResourceWithHttpInfo(table, deleteid, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'table' is set
      if (table === undefined || table === null) {
        throw new Error("Missing the required parameter 'table' when calling deleteItemResource");
      }
      // verify the required parameter 'deleteid' is set
      if (deleteid === undefined || deleteid === null) {
        throw new Error("Missing the required parameter 'deleteid' when calling deleteItemResource");
      }
      var pathParams = {
        table: table,
        deleteid: deleteid
      };
      var queryParams = {
        overrideMethod: "DELETE"
      };
      var headerParams = {
        "X-HTTP-Method-Override": "DELETE"
      };
      var formParams = {};
      var authNames = ["usersession"];
      var contentTypes = [];
      var accepts = ["*/*"];
      var returnType = Object;
      return this.apiClient.callApi("/rest/{table}/{deleteid}", "POST", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * Delete bentity item from the database
     * @param {<&vendorExtensions.x-jsdoc-type>} table
     * @param {<&vendorExtensions.x-jsdoc-type>} deleteid
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.xHTTPMethodOverride  (default to <.>)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "deleteItemResource",
    value: function deleteItemResource(table, deleteid, opts) {
      return this.deleteItemResourceWithHttpInfo(table, deleteid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Delete saved record from folder by folderId and docId (guid)
     * @param {String} folderId
     * @param {Array.<String>} guid
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "deleteSavedRecordWithHttpInfo",
    value: function deleteSavedRecordWithHttpInfo(folderId, guid) {
      var postBody = null;
      // verify the required parameter 'folderId' is set
      if (folderId === undefined || folderId === null) {
        throw new Error("Missing the required parameter 'folderId' when calling deleteSavedRecord");
      }
      // verify the required parameter 'guid' is set
      if (guid === undefined || guid === null) {
        throw new Error("Missing the required parameter 'guid' when calling deleteSavedRecord");
      }
      var pathParams = {};
      var queryParams = {
        folderId: folderId,
        guid: this.apiClient.buildCollectionParam(guid, "multi")
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ["usersession"];
      var contentTypes = [];
      var accepts = ["*/*"];
      var returnType = Object;
      return this.apiClient.callApi("/rest/savedRecords/search/deleteByFolderIdAndGuidIn", "GET", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * Delete saved record from folder by folderId and docId (guid)
     * @param {<&vendorExtensions.x-jsdoc-type>} folderId
     * @param {<&vendorExtensions.x-jsdoc-type>} guid
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "deleteSavedRecord",
    value: function deleteSavedRecord(folderId, guid) {
      return this.deleteSavedRecordWithHttpInfo(folderId, guid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get entity item collection from backing database
     * @param {module:model/String} table Table name
     * @param {Object} opts Optional parameters
     * @param {String} opts.page Page number, starting with 0
     * @param {String} opts.size Page size, go with 1000 to get all items w/o pagination needed
     * @param {String} opts.sort Sort field and direction. Example handle,desc
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/HateoasResourcesHateoasResourceMapStringObject} and HTTP response
     */
  }, {
    key: "getCollectionResourceWithHttpInfo",
    value: function getCollectionResourceWithHttpInfo(table, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'table' is set
      if (table === undefined || table === null) {
        throw new Error("Missing the required parameter 'table' when calling getCollectionResource");
      }
      var pathParams = {
        table: table
      };
      var queryParams = {
        page: opts["page"],
        size: opts["size"],
        sort: opts["sort"]
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ["usersession"];
      var contentTypes = [];
      var accepts = ["*/*"];
      var returnType = Object;
      return this.apiClient.callApi("/rest/{table}", "GET", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * Get entity item collection from backing database
     * @param {<&vendorExtensions.x-jsdoc-type>} table Table name
     * @param {Object} opts Optional parameters
     * @param {String} opts.page Page number, starting with 0
     * @param {String} opts.size Page size, go with 1000 to get all items w/o pagination needed
     * @param {String} opts.sort Sort field and direction. Example handle,desc
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/HateoasResourcesHateoasResourceMapStringObject}
     */
  }, {
    key: "getCollectionResource",
    value: function getCollectionResource(table, opts) {
      return this.getCollectionResourceWithHttpInfo(table, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get an entity item by id from the database
     * @param {String} id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/HateoasResourceMapStringObject} and HTTP response
     */
  }, {
    key: "getItemResourceWithHttpInfo",
    value: function getItemResourceWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getItemResource");
      }
      var pathParams = {
        id: id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ["usersession"];
      var contentTypes = [];
      var accepts = ["*/*"];
      var returnType = Object;
      return this.apiClient.callApi("/rest/{table}/{id}", "GET", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * Get an entity item by id from the database
     * @param {<&vendorExtensions.x-jsdoc-type>} id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/HateoasResourceMapStringObject}
     */
  }, {
    key: "getItemResource",
    value: function getItemResource(id) {
      return this.getItemResourceWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Patch existing entity item in the database. Only send part of entity that changed
     * @param {{String: Object}} body
     * @param {module:model/String} table
     * @param {String} patchid
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.xHTTPMethodOverride  (default to <.>)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/HateoasResourceMapStringObject} and HTTP response
     */
  }, {
    key: "patchItemResourceWithHttpInfo",
    value: function patchItemResourceWithHttpInfo(body, table, patchid, opts) {
      opts = opts || {};
      var postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling patchItemResource");
      }
      // verify the required parameter 'table' is set
      if (table === undefined || table === null) {
        throw new Error("Missing the required parameter 'table' when calling patchItemResource");
      }
      // verify the required parameter 'patchid' is set
      if (patchid === undefined || patchid === null) {
        throw new Error("Missing the required parameter 'patchid' when calling patchItemResource");
      }
      var pathParams = {
        table: table,
        patchid: patchid
      };
      var queryParams = {
        overrideMethod: "PATCH"
      };
      var headerParams = {
        "X-HTTP-Method-Override": "PATCH"
      };
      var formParams = {};
      var authNames = ["usersession"];
      var contentTypes = ["application/json"];
      var accepts = ["*/*"];
      var returnType = Object;
      return this.apiClient.callApi("/rest/{table}/{patchid}", "POST", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * Patch existing entity item in the database. Only send part of entity that changed
     * @param {<&vendorExtensions.x-jsdoc-type>} body
     * @param {<&vendorExtensions.x-jsdoc-type>} table
     * @param {<&vendorExtensions.x-jsdoc-type>} patchid
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.xHTTPMethodOverride  (default to <.>)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/HateoasResourceMapStringObject}
     */
  }, {
    key: "patchItemResource",
    value: function patchItemResource(body, table, patchid, opts) {
      return this.patchItemResourceWithHttpInfo(body, table, patchid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create a new entity item in the database
     * @param {{String: Object}} body
     * @param {module:model/String} table
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/HateoasResourceMapStringObject} and HTTP response
     */
  }, {
    key: "postCollectionResourceWithHttpInfo",
    value: function postCollectionResourceWithHttpInfo(body, table) {
      var postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling postCollectionResource");
      }
      // verify the required parameter 'table' is set
      if (table === undefined || table === null) {
        throw new Error("Missing the required parameter 'table' when calling postCollectionResource");
      }
      var pathParams = {
        table: table
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ["usersession"];
      var contentTypes = ["application/json"];
      var accepts = ["*/*"];
      var returnType = Object;
      return this.apiClient.callApi("/rest/{table}", "POST", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * Create a new entity item in the database
     * @param {<&vendorExtensions.x-jsdoc-type>} body
     * @param {<&vendorExtensions.x-jsdoc-type>} table
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/HateoasResourceMapStringObject}
     */
  }, {
    key: "postCollectionResource",
    value: function postCollectionResource(body, table) {
      return this.postCollectionResourceWithHttpInfo(body, table).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Overwrite existing entity item in the database
     * @param {{String: Object}} body
     * @param {module:model/String} table
     * @param {String} putid
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.xHTTPMethodOverride  (default to <.>)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/HateoasResourceMapStringObject} and HTTP response
     */
  }, {
    key: "putItemResourceWithHttpInfo",
    value: function putItemResourceWithHttpInfo(body, table, putid, opts) {
      opts = opts || {};
      var postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling putItemResource");
      }
      // verify the required parameter 'table' is set
      if (table === undefined || table === null) {
        throw new Error("Missing the required parameter 'table' when calling putItemResource");
      }
      // verify the required parameter 'putid' is set
      if (putid === undefined || putid === null) {
        throw new Error("Missing the required parameter 'putid' when calling putItemResource");
      }
      var pathParams = {
        table: table,
        putid: putid
      };
      var queryParams = {
        overrideMethod: "PUT"
      };
      var headerParams = {
        "X-HTTP-Method-Override": "PUT"
      };
      var formParams = {};
      var authNames = ["usersession"];
      var contentTypes = ["application/json"];
      var accepts = ["*/*"];
      var returnType = Object;
      return this.apiClient.callApi("/rest/{table}/{putid}", "POST", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * Overwrite existing entity item in the database
     * @param {<&vendorExtensions.x-jsdoc-type>} body
     * @param {<&vendorExtensions.x-jsdoc-type>} table
     * @param {<&vendorExtensions.x-jsdoc-type>} putid
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.xHTTPMethodOverride  (default to <.>)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/HateoasResourceMapStringObject}
     */
  }, {
    key: "putItemResource",
    value: function putItemResource(body, table, putid, opts) {
      return this.putItemResourceWithHttpInfo(body, table, putid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
  return EvRepositoryApi;
}();